import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'What is SyNeural?',
    answer: 'SyNeural is the parent organization and platform architecture behind the CJI and NCJI frameworks. It provides the technological, analytical, and developmental infrastructure required to measure and improve human reasoning, institutional readiness, and leadership capability at scale.'
  }, {
    question: 'What is the difference between CJI and NCJI?',
    answer: 'CJI (Civic Judgment Index) focuses primarily on decision-quality analytics, propaganda resistance, and cognitive assessment. NCJI (Neurocognitive Civic Judgment Index) is the broader developmental architecture that integrates those metrics into a full lifecycle system, mapping human opportunity, institutional readiness, and executive evaluation.'
  }, {
    question: 'Is NCJI just a score?',
    answer: 'No. NCJI is a progression system, not a static score. It is designed to identify capability gaps and immediately pair them with developmental pathways, institutional support, and actionable recommendations to build readiness over time.'
  }, {
    question: 'Who is the platform for?',
    answer: 'The platform serves multiple layers of society: educational institutions developing youth capability, employers seeking better execution and leadership, civil society organizations building resilience, and governments modernizing civil service and executive readiness.'
  }, {
    question: 'How does it scale globally?',
    answer: 'The architecture is designed to operate at municipal, regional, and national levels. It provides localized insights for community development while aggregating macro-level data to serve as a strategic intelligence layer for national capability planning and governance stability.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-562">
      <div className="text-center mb-12" data-id="element-563">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-564">
          Frequently Asked Questions
        </h2>
      </div>

      <div className="space-y-4" data-id="element-565">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.1
      }} className="border border-line rounded-lg bg-white overflow-hidden" data-id="element-566">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-567">
              <span className="text-lg font-heading font-bold text-ink-dark pr-8" data-id="element-568">
                {faq.question}
              </span>
              <span className="text-navy flex-shrink-0" data-id="element-569">
                {openIndex === index ? <Minus size={20} data-id="element-570" /> : <Plus size={20} data-id="element-571" />}
              </span>
            </button>

            <AnimatePresence data-id="element-572">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} data-id="element-573">
                  <div className="px-6 pb-6 text-ink-muted leading-relaxed" data-id="element-574">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}